type LegacyGetUserMedia = (
  constraints: MediaStreamConstraints,
  onSuccess: (stream: MediaStream) => void,
  onError: (error: DOMException) => void,
) => void;

type NavigatorWithLegacyGetUserMedia = Navigator & {
  webkitGetUserMedia?: LegacyGetUserMedia;
  mozGetUserMedia?: LegacyGetUserMedia;
  msGetUserMedia?: LegacyGetUserMedia;
  getUserMedia?: LegacyGetUserMedia;
};

export function getCompatibleGetUserMedia():
  | ((constraints: MediaStreamConstraints) => Promise<MediaStream>)
  | null {
  if (typeof navigator === "undefined") {
    return null;
  }
  if (navigator.mediaDevices?.getUserMedia) {
    return (constraints: MediaStreamConstraints) =>
      navigator.mediaDevices.getUserMedia(constraints);
  }

  const legacyNavigator = navigator as NavigatorWithLegacyGetUserMedia;
  const legacyGetUserMedia =
    legacyNavigator.webkitGetUserMedia ||
    legacyNavigator.mozGetUserMedia ||
    legacyNavigator.msGetUserMedia ||
    legacyNavigator.getUserMedia;
  if (!legacyGetUserMedia) {
    return null;
  }

  return (constraints: MediaStreamConstraints) =>
    new Promise<MediaStream>((resolve, reject) => {
      legacyGetUserMedia.call(legacyNavigator, constraints, resolve, reject);
    });
}

export function supportsWebVoiceRecording(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }
  const AudioContextCtor =
    window.AudioContext ||
    (window as Window & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;

  return !!getCompatibleGetUserMedia() && !!AudioContextCtor;
}
